import * as z from "zod";
import type { Ctx } from "../../types";
import { FormAction } from "gg-wf-scripts";
import { parse } from "../_helpers";

const set_password_schema = z
  .object({
    password: z
      .string({ error: "Password is required" })
      .min(8, "Password must be at least 8 characters"),
    confirm_password: z
      .string({ error: "Confirm Password is required" })
      .min(1, "Confirm Password is required"),
  })
  .refine((d) => d.password === d.confirm_password, {
    message: "Passwords do not match",
    path: ["confirm_password"],
  });

export const set_password: FormAction<Ctx> = async (
  { sb },
  formData,
  _params
) => {
  const parsed = parse(set_password_schema, formData);
  if (!parsed.ok) return parsed;

  const { data, error } = await sb.auth.updateUser({
    password: parsed.data.password,
  });
  if (error) return { ok: false, error: error.message };

  const role = data.user?.app_metadata?.role;
  switch (role) {
    case "superuser":
      window.location.href = "/app/admin/dashboard";
      break;
    case "school_admin":
      window.location.href = "/app/school/dashboard";
      break;
    case "substitute":
      window.location.href = "/app/open-jobs";
      break;
    default:
      window.location.href = "/";
  }
  return { ok: true };
};
